// export const font = "Atlas Grotesk";
export const font = "Poppins";
export const fontStyle = "normal";
export const fontWeight = 300;
export const fontSize = "15px";
export const fontHeight = "19px";

export const colorGray = "#8596AF";
export const colorBlack = "#292D37";
export const colorBlue = "#063AC9";
export const focusedBlue = "#3965DE";
export const focusedColor = "#B7C0D0";
export const selectedColor = "#F2F2F2";
export const colorInvalid = "#E46262";
export const searchInputColor = "#4A5164";
export const searchBorder = "#F3F6FF";

export const backgroundColorWhite = "#FFFFFF";
export const borderRadius2 = "2px";
export const border = "1px solid #E6EDF5";
export const borderInvalid = "2px solid #E46262";
export const textAlignCenter = "center";

export function getBackgrounColor(
  { backgroundColor },
  { isFocused, isSelected }
) {
  if (isFocused) return focusedColor;
  if (isSelected) return selectedColor;
  return backgroundColor;
}

export function getColor({ isFocused, isSelected }) {
  if (isFocused) return focusedBlue;
  if (isSelected) return colorBlue;
  return "#192A3E";
}
